/**
 * Logic for TypeStaffProfiles component
 */
(function(jQuery) {
    'use strict';

    function ProjectsAbroadStaffProfiles() {
        var global = {};

        var fn = {
            init: function() {
                jQuery('.js-staff-profile-destination').on(
                    'change',
                    fn.getNewStaff
                );

                // hide livechat when staff profile opened
                jQuery(
                    '.TypeTeam *[data-toggle="modal"], .TypeStaffProfiles *[data-toggle="modal"]'
                ).each(function() {
                    var modalTrigger = jQuery(this);
                    var modal = jQuery(
                        modalTrigger.data('target') || modalTrigger.attr('href')
                    );

                    modal.on('show.bs.modal', function() {
                        if (window.innerWidth < 900) {
                            jQuery('#hubspot-messages-iframe-container').addClass('js-livechat-hidden');
                            modal.one('hide.bs.modal', function() {
                                jQuery('#hubspot-messages-iframe-container').removeClass('js-livechat-hidden');
                            });
                        }
                    });
                });
            },

            getNewStaff: function() {
                var data = {
                    'selected-destination-id': jQuery(
                        '.js-staff-profile-destination'
                    ).val(),
                };

                jQuery.get(
                    '/staff-profiles',
                    data,
                    function(data) {
                        jQuery('.js-team-members').html(data.html);
                    },
                    'json'
                );
            },
        };

        jQuery(fn.init);
    }

    new ProjectsAbroadStaffProfiles();
})(jQuery);
